module.exports = __webpack_public_path__ + "img/image2.f4e6335f.webp";